import { api } from "./api";
import { trackUnsavedInput } from "./generics";
import { renderPostHocNotifyPrompt } from "./notifyEmail";

// Formularz "+ Dodaj koło naukowe" na katalogu kół naukowych (browse_kola_naukowe.html) - dużo
// prostszy niż addSubject.ts (bez wyszukiwarki/podpowiedzi - koła nie mają odpowiednika
// "przedmiotu z USOS" do dopasowania), bo w odróżnieniu od przedmiotu (bramka AI, auto-publikacja)
// zgłoszenie koła ZAWSZE trafia do ręcznej moderacji administratora (patrz KoloNaukowe.status w
// models.py) - nie ma więc scenariusza "od razu aktywne, przejdź na jego stronę".
//
// TYLKO mały przycisk pod wynikami wyszukiwania (na wyraźną prośbę - "wiesz o co cho"), ten sam
// wzorzec co "Nie znalazłeś przedmiotu?"/renderAddSubjectButton w addSubject.ts i
// "Nie znalazłeś wykładowcy?" w addLecturer.ts - bez dużego, zawsze widocznego CTA w pasku
// kontrolek (kolaNaukoweBrowser.ts w ogóle go nie renderuje).
let openDialog: HTMLDialogElement | null = null;

export function renderAddKoloNaukoweButton(
    container: HTMLElement, facultyId: number, getPrefillQuery: () => string,
): void {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "add-comment-btn";
    const icon = document.createElement("span");
    icon.className = "add-comment-btn-icon";
    icon.setAttribute("aria-hidden", "true");
    icon.textContent = "+";
    btn.append(icon, " Dodaj koło naukowe");
    btn.addEventListener("click", () => openAddKoloNaukoweDialog(facultyId, getPrefillQuery()));
    container.appendChild(btn);
}

function openAddKoloNaukoweDialog(facultyId: number, prefillQuery: string): void {
    openDialog?.close();

    const dialog = document.createElement("dialog");
    dialog.className = "add-review-dialog add-person-dialog";

    const title = document.createElement("h2");
    title.className = "add-review-dialog-title";
    title.textContent = "Dodaj koło naukowe";

    const closeBtn = document.createElement("button");
    closeBtn.type = "button";
    closeBtn.className = "add-review-dialog-close";
    closeBtn.setAttribute("aria-label", "Zamknij");
    closeBtn.innerHTML = "&times;";
    closeBtn.addEventListener("click", () => dialog.close());

    const formContainer = document.createElement("div");
    formContainer.className = "comment-form-box";

    dialog.append(title, closeBtn, formContainer);
    document.body.appendChild(dialog);

    dialog.addEventListener("click", (event) => {
        if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener("close", () => {
        if (openDialog === dialog) openDialog = null;
        dialog.remove();
    });
    openDialog = dialog;
    dialog.showModal();

    renderAddKoloNaukoweForm(formContainer, facultyId, prefillQuery);
}

function renderAddKoloNaukoweForm(container: HTMLElement, facultyId: number, prefillQuery: string): void {
    const form = document.createElement("form");

    const nameLabel = document.createElement("span");
    nameLabel.className = "field-label-text comment-body-label";
    nameLabel.textContent = "Nazwa koła:";

    const nameInput = document.createElement("input");
    nameInput.type = "text";
    nameInput.required = true;
    nameInput.maxLength = 200;
    nameInput.value = prefillQuery;
    trackUnsavedInput(nameInput);

    const nameError = document.createElement("span");
    nameError.className = "error";

    const nameFieldWrap = document.createElement("div");
    nameFieldWrap.className = "comment-body-field";
    nameFieldWrap.append(nameLabel, nameInput, nameError);

    const descriptionLabel = document.createElement("span");
    descriptionLabel.className = "field-label-text comment-body-label";
    descriptionLabel.textContent = "Krótki opis (opcjonalnie):";

    const descriptionTextarea = document.createElement("textarea");
    descriptionTextarea.rows = 3;
    descriptionTextarea.placeholder = "Czym zajmuje się koło, kiedy powstało...";
    trackUnsavedInput(descriptionTextarea);

    const descriptionFieldWrap = document.createElement("div");
    descriptionFieldWrap.className = "comment-body-field";
    descriptionFieldWrap.append(descriptionLabel, descriptionTextarea);

    const submitBtn = document.createElement("button");
    submitBtn.type = "submit";
    submitBtn.textContent = "Zgłoś koło naukowe";

    const bottomRow = document.createElement("div");
    bottomRow.className = "comment-form-bottom-row";
    bottomRow.appendChild(submitBtn);

    const feedback = document.createElement("p");
    const notifyPromptContainer = document.createElement("div");

    form.append(nameFieldWrap, descriptionFieldWrap, bottomRow, feedback, notifyPromptContainer);

    form.addEventListener("submit", async (event) => {
        event.preventDefault();
        nameError.textContent = "";
        feedback.textContent = "";
        feedback.classList.remove("error");

        const name = nameInput.value.trim();
        if (name.length < 3) {
            nameError.textContent = "Nazwa musi mieć co najmniej 3 znaki.";
            return;
        }

        submitBtn.disabled = true;
        feedback.textContent = "Zapisywanie...";

        const result = await api.createKoloNaukowe(name, descriptionTextarea.value.trim(), facultyId);

        if (result.ok) {
            form.replaceChildren();
            const thanks = document.createElement("p");
            thanks.textContent = `Dziękujemy! Koło „${name}” zostanie opublikowane po sprawdzeniu przez administratora.`;
            form.append(thanks, renderPostHocNotifyPrompt([{ model: "kolo_naukowe", pk: result.data.kolo_naukowe.id }]));
        } else {
            feedback.classList.add("error");
            feedback.textContent = `Błąd: ${result.error}`;
            submitBtn.disabled = false;
        }
    });

    container.appendChild(form);
}
